import axios from 'axios';
import { useEffect, useState } from 'react';
import getAPI from '../../service/getAPI';
import { Button, Form } from 'react-bootstrap';
import { format } from 'date-fns';

const RefundList = ({ search, setSearch }) => {
    const { master } = getAPI();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [sending, setSending] = useState(false);
    const [page, setPage] = useState(1);
    const [message, setMessage] = useState({ text: '', type: '' });
    const [limit, setLimit] = useState(() => {
        // Get saved limit or default to 10
        const saved = localStorage.getItem("pageLimit");
        return saved ? parseInt(saved, 10) : 10;
    });

    useEffect(() => {
        // Store current limit in localStorage
        localStorage.setItem("pageLimit", limit);
    }, [limit]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [totalPages, setTotalPages] = useState(1);
    const [selectedRefunds, setSelectedRefunds] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    // const [search, setSearch] = useState("");
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");

    useEffect(() => {
        fetchData(page);
    }, [page, limit, search, fromDate, toDate]);

    const fetchData = async (currentPage) => {
        try {
            setLoading(true);
            const response = await axios.post(master.RefundList, {
                page: currentPage,
                limit: limit,
                search,
                from_date: fromDate,
                to_date: toDate,
            });

            if (response.data.flag === 1 && response.data.code === 200) {
                const resData = response.data.data;
                const records = resData.data || [];
                const pagination = resData.pagination || {};

                setData(records);
                setTotalRecords(resData.pagination?.totalRecords || 0);
                setTotalPages(pagination.totalPages || 1);
                setPage(pagination.currentPage || currentPage);
            } else {
                setData([]);
                setTotalPages(1);
            }
        } catch (error) {
            console.error('Error fetching refund list:', error);
            setData([]);
            setTotalPages(1);
        } finally {
            setLoading(false);
        }
    };

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) {
            setPage(newPage);
            setSelectedRefunds([]);
            setSelectAll(false);
        }
    };

    const handleSelectRefund = (refundId) => {
        setSelectedRefunds(prev =>
            prev.includes(refundId)
                ? prev.filter(id => id !== refundId)
                : [...prev, refundId]
        );
    };

    const handleSelectAll = () => {
        if (selectAll) {
            setSelectedRefunds([]);
        } else {
            const allIds = data.map(item => item.inquiry_id);
            setSelectedRefunds(allIds);
        }
        setSelectAll(!selectAll);
    };

    // Auto-dismiss message after 2 seconds
    useEffect(() => {
        if (message.text) {
            const timer = setTimeout(() => {
                setMessage({ text: '', type: '' });
            }, 2000);
            return () => clearTimeout(timer);
        }
    }, [message]);

    const handleSendBulkMessage = async () => {
        if (selectedRefunds.length === 0) {
            setMessage({ text: 'Please select at least one refund to send message', type: 'warning' });
            return;
        }

        try {
            setSending(true);
            setMessage({ text: '', type: '' });

            // Prepare the payload with selected refunds
            const selectedData = data.filter(item => selectedRefunds.includes(item.inquiry_id));
            const payload = {
                selectedRefunds: selectedData.map(item => ({
                    name: item.customer_name || 'Customer',
                    mobile: item.phone_number || '',
                    amount: item.refund_amount || 0,
                    upi: item.refund_method || ''
                }))
            };

            // Call the API
            const response = await axios.post(master.sendInquiryBulkMessage, payload);

            if (response.data.flag === 1 && response.data.code === 200) {
                setMessage({ text: 'Messages sent successfully!', type: 'success' });
                // Clear selection after successful send
                setSelectedRefunds([]);
                setSelectAll(false);
            } else {
                throw new Error(response.data.message || 'Failed to send messages');
            }
        } catch (error) {
            console.error('Error sending bulk messages:', error);
            setMessage({
                text: error.response?.data?.message || 'Error sending messages. Please try again.',
                type: 'danger'
            });
        } finally {
            setSending(false);
        }
    };

    useEffect(() => {
        // Update select all state based on current selection
        if (data.length > 0) {
            const allSelected = data.every(item => selectedRefunds.includes(item.inquiry_id));
            setSelectAll(allSelected && data.length > 0);
        }
    }, [selectedRefunds, data]);

    return (
        <>
            {/* <main id="main" className="main"> */}
            {/* <div className="pagetitle">
                <h1>Refund List</h1>
                <nav>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                            <a href="/">Masters</a>
                        </li>
                        <li className="breadcrumb-item active">Refund</li>
                    </ol>
                </nav>
            </div> */}

            <Form className="row g-2 mb-3">
                <div className="col-md-3 gap-2">
                    <Form.Control
                        type="text"
                        placeholder="Search by mobile, remark etc."
                        value={search}
                        onChange={(e) => {
                            const input = e.target.value;
                            const cleaned = input.replace(/\s+/g, ''); // removes all whitespace
                            setSearch(cleaned);
                        }}
                    />
                </div>
                <div className="col-md-2">
                    <Form.Control
                        type="date"
                        value={fromDate}
                        onChange={(e) => setFromDate(e.target.value)}
                    />
                </div>
                <div className="col-md-2">
                    <Form.Control
                        type="date"
                        value={toDate}
                        onChange={(e) => setToDate(e.target.value)}
                    />
                </div>
                <div className="col-md-2 gap-2 d-flex">
                    <Button
                        variant="primary"
                        onClick={() => {
                            setPage(1);
                            // fetchData(page, limit);
                        }}
                    >
                        Search
                    </Button>
                    <Button
                        variant="secondary"
                        onClick={() => {
                            setSearch("");
                            setFromDate("");
                            setToDate("");
                            // setPage(1);
                            // fetchData(page, limit);
                        }}
                    >
                        Reset
                    </Button>
                </div>
            </Form>

            <div className="container-fluid p-0">
                {loading ? (
                    <div className="text-center my-4">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                ) : (
                    <>
                        <div className="table-responsive">
                            {selectedRefunds.length > 0 && (
                                <div className="mb-3 d-flex align-items-center">
                                    <div className="flex-grow-1">
                                        <span className="text-muted">
                                            Selected {selectedRefunds.length} inquir{selectedRefunds.length === 1 ? 'y' : 'ies'}
                                        </span>
                                    </div>
                                    <div className="d-flex gap-2">
                                        <button
                                            className="btn btn-success"
                                            onClick={handleSendBulkMessage}
                                            disabled={sending}
                                        >
                                            {sending ? (
                                                <>
                                                    <span
                                                        className="spinner-border spinner-border-sm me-2"
                                                        role="status"
                                                        aria-hidden="true"
                                                    ></span>
                                                    Sending...
                                                </>
                                            ) : (
                                                'Send WhatsApp Message'
                                            )}
                                        </button>
                                    </div>
                                </div>
                            )}
                            {message.text && (
                                <div className={`alert alert-${message.type} alert-dismissible fade show`} role="alert">
                                    <i className={`bi ${message.type === 'success' ? 'bi-check-circle' : 'bi-exclamation-triangle'}-fill me-2`}></i>
                                    {message.text}
                                    <button
                                        type="button"
                                        className="btn-close"
                                        onClick={() => setMessage({ text: '', type: '' })}
                                        aria-label="Close">
                                    </button>
                                </div>
                            )}

                            <table className="table table-bordered table-hover">
                                <thead className="table-light">
                                    <tr>
                                        <th>
                                            <div className="form-check">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    checked={selectAll}
                                                    onChange={handleSelectAll}
                                                />
                                            </div>
                                        </th>
                                        <th>No</th>
                                        <th>Customer Name</th>
                                        <th>Mobile No</th>
                                        <th>Address</th>
                                        <th>Refund Amount</th>
                                        <th>UPI ID</th>
                                        {/* <th>Resolved</th> */}
                                        <th>Created At</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.length > 0 ? (
                                        data.map((item, index) => (
                                            <tr key={item.inquiry_id}>
                                                <td>
                                                    <div className="form-check">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            checked={selectedRefunds.includes(item.inquiry_id)}
                                                            onChange={() => handleSelectRefund(item.inquiry_id)}
                                                        />
                                                    </div>
                                                </td>
                                                <td>{(page - 1) * limit + index + 1}</td>
                                                <td>{item.customer_name || "-"}</td>
                                                <td>{item.phone_number || "-"}</td>
                                                <td>
                                                    {[
                                                        item.address,
                                                        item.state,
                                                        item.pincode,
                                                    ]
                                                        .filter(Boolean)
                                                        .join(", ") || "-"}
                                                </td>
                                                <td>{item.refund_amount || "0.0"}</td>
                                                <td>{item.refund_method || "-"}</td>
                                                {/* <td>{item.is_resolved ? 'Yes' : 'No'}</td> */}
                                                <td>{item.created_at
                                                    ? format(new Date(item.created_at), "dd-MM-yyyy hh:mm a")
                                                    : "N/A"}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="8" className="text-center">
                                                No records found.
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>

                        {/* Pagination */}
                        <nav className="d-flex justify-content-between align-items-center mt-3">
                            <div>Total Records: {totalRecords}</div>

                            <div className="d-flex align-items-center gap-2">
                                <Form.Label className="mb-0 me-2">Show:</Form.Label>
                                <Form.Select
                                    value={limit}
                                    onChange={(e) => {
                                        setLimit(Number(e.target.value));
                                        setPage(1);
                                    }}
                                    style={{ width: "100px" }}
                                >
                                    {[10, 25, 50, 100].map((num) => (
                                        <option key={num} value={num}>
                                            {num}
                                        </option>
                                    ))}
                                </Form.Select>

                                <Button
                                    variant="primary"
                                    className="mx-2"
                                    disabled={page === 1}
                                    onClick={() => setPage(page - 1)}
                                >
                                    &laquo; Prev
                                </Button>

                                <Form.Select
                                    value={page}
                                    onChange={(e) => handlePageChange(Number(e.target.value))}
                                    style={{ width: "100px" }}
                                >
                                    {Array.from({ length: totalPages }, (_, i) => (
                                        <option key={i + 1} value={i + 1}>
                                            Page {i + 1}
                                        </option>
                                    ))}
                                </Form.Select>

                                <Button
                                    variant="primary"
                                    className="mx-2"
                                    disabled={page === totalPages}
                                    onClick={() => setPage(page + 1)}
                                >
                                    Next &raquo;
                                </Button>
                            </div>
                        </nav>
                    </>
                )}
            </div>
            {/* </main> */}
        </>
    );
};

export default RefundList;
